var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoInterviews(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170.269,
    height: 194.647,
    viewBox: "0 0 170.269 194.647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2375",
    "data-name": "Group 2375",
    transform: "translate(-342 -1093.292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2369",
    "data-name": "Group 2369",
    transform: "translate(342 1093.292)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_540",
    "data-name": "Ellipse 540",
    cx: 78.254,
    cy: 78.254,
    r: 78.254,
    transform: "translate(0 15.122)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2358",
    "data-name": "Group 2358",
    transform: "translate(21.245 28.932)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_593",
    "data-name": "Rectangle 593",
    width: 114.372,
    height: 78.608,
    rx: 8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_595",
    "data-name": "Rectangle 595",
    width: 26.557,
    height: 5.311,
    rx: 2.656,
    transform: "translate(9.915 11.331)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_609",
    "data-name": "Rectangle 609",
    width: 26.557,
    height: 5.311,
    rx: 2.656,
    transform: "translate(9.915 27.973)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_612",
    "data-name": "Rectangle 612",
    width: 26.557,
    height: 5.311,
    rx: 2.656,
    transform: "translate(9.915 44.616)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_615",
    "data-name": "Rectangle 615",
    width: 26.557,
    height: 5.311,
    rx: 2.656,
    transform: "translate(9.915 61.258)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_607",
    "data-name": "Rectangle 607",
    width: 26.557,
    height: 5.311,
    rx: 2.656,
    transform: "translate(43.907 11.331)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_610",
    "data-name": "Rectangle 610",
    width: 26.557,
    height: 5.311,
    rx: 2.656,
    transform: "translate(43.907 27.973)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_613",
    "data-name": "Rectangle 613",
    width: 26.557,
    height: 5.311,
    rx: 2.656,
    transform: "translate(43.907 44.616)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_616",
    "data-name": "Rectangle 616",
    width: 26.557,
    height: 5.311,
    rx: 2.656,
    transform: "translate(43.907 61.258)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_608",
    "data-name": "Rectangle 608",
    width: 26.557,
    height: 5.311,
    rx: 2.656,
    transform: "translate(77.9 11.331)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_611",
    "data-name": "Rectangle 611",
    width: 26.557,
    height: 5.311,
    rx: 2.656,
    transform: "translate(77.9 27.973)",
    fill: "#195cff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_614",
    "data-name": "Rectangle 614",
    width: 26.557,
    height: 5.311,
    rx: 2.656,
    transform: "translate(77.9 44.616)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_617",
    "data-name": "Rectangle 617",
    width: 26.557,
    height: 5.311,
    rx: 2.656,
    transform: "translate(77.9 61.258)",
    fill: "#dce5f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2363",
    "data-name": "Group 2363",
    transform: "translate(21.245 116.038)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_593-2",
    "data-name": "Rectangle 593",
    width: 114.372,
    height: 78.608,
    rx: 8,
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_595-2",
    "data-name": "Rectangle 595",
    width: 26.557,
    height: 5.311,
    rx: 2.656,
    transform: "translate(9.915 11.331)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_609-2",
    "data-name": "Rectangle 609",
    width: 26.557,
    height: 5.311,
    rx: 2.656,
    transform: "translate(9.915 27.973)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_612-2",
    "data-name": "Rectangle 612",
    width: 26.557,
    height: 5.311,
    rx: 2.656,
    transform: "translate(9.915 44.616)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_607-2",
    "data-name": "Rectangle 607",
    width: 26.557,
    height: 5.311,
    rx: 2.656,
    transform: "translate(43.907 11.331)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_610-2",
    "data-name": "Rectangle 610",
    width: 26.557,
    height: 5.311,
    rx: 2.656,
    transform: "translate(43.907 27.973)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_613-2",
    "data-name": "Rectangle 613",
    width: 26.557,
    height: 5.311,
    rx: 2.656,
    transform: "translate(43.907 44.616)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_608-2",
    "data-name": "Rectangle 608",
    width: 26.557,
    height: 5.311,
    rx: 2.656,
    transform: "translate(77.9 11.331)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_611-2",
    "data-name": "Rectangle 611",
    width: 26.557,
    height: 5.311,
    rx: 2.656,
    transform: "translate(77.9 27.973)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_614-2",
    "data-name": "Rectangle 614",
    width: 26.557,
    height: 5.311,
    rx: 2.656,
    transform: "translate(77.9 44.616)",
    fill: "#dce5f4"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_601",
    "data-name": "Rectangle 601",
    width: 29.036,
    height: 3.895,
    rx: 1.948,
    transform: "translate(137.43 29.676) rotate(-45)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_602",
    "data-name": "Rectangle 602",
    width: 16.996,
    height: 3.895,
    rx: 1.948,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 152.843, 43.216)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_603",
    "data-name": "Rectangle 603",
    width: 18.059,
    height: 3.895,
    rx: 1.948,
    transform: "matrix(0.259, -0.966, 0.966, 0.259, 120.676, 17.443)",
    fill: "#dce5f4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInterviews);
export default __webpack_public_path__ + "static/media/no-interviews.264fa1105dc5d7956b3ab4898b6c6e8a.svg";
export { ForwardRef as ReactComponent };